import { IonContent } from '@ionic/react';
import styled from 'styled-components';

export const StyledIonContent = styled(IonContent)`
  &::part(background) {
    background-color: #ffffff;
  }
`;
